import Axios from "axios";
import Cookies from "js-cookie";
/* eslint-disable */
export const postAsyncWithToken = (url, data) =>
  new Promise(async (resolve, reject) => {
    try {
      const response = await Axios.post(url, data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: Cookies.get("autoketing_seo_session"),
        },
      });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
/* eslint-disable */
export const getAsyncWithToken = url =>
  new Promise(async (resolve, reject) => {
    try {
      const response = await Axios.get(url, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: Cookies.get("autoketing_seo_session"),
        },
      });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
/* eslint-disable */
export const postAsyncWithTokenFormData = (url, data) =>
  new Promise(async (resolve, reject) => {
    try {
      const response = await Axios.post(url, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: Cookies.get("autoketing_seo_session"),
        },
      });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
